<template>
  <div :class="textClasses" class="paragraph-dark-gray block-copyright">
    © {{ new Date().getFullYear() }}<span v-if="!$mq.phone">, </span>
    <a :class="textClasses" :href="url" target="_blank" class="dark-gray-link">{{ footerTitle }}</a>
  </div>
</template>
<script>

import * as contexts from 'top20common/distribution/constants/contexts';
import * as utils from 'top20common/distribution/themes/utils';

export default {
  computed: {
    url(){
      const prefix = this.$language.isEnglish() ? "en/": "";
      return `https://www.cgpgroup.com/${prefix}site/job_Search`;
    },
    textClasses() {
      return this.$mq.phone ? 'paragraph-s' : 'paragraph';
    },
    copyrights() {
      return {
        [contexts.TOP20TALENT]: 'Top20Talent',
        [contexts.CGPO2O]: this.$gettext('CGP O2O'),
        [contexts.TOP20TECH]: this.$gettext('Top20Tech')
      };
    },
    defaultCopyright() {
      return this.copyrights['top20'];
    },
    footerTitle() {
      return this.copyrights[utils.getCurrentContext()] || this.defaultCopyright;
    }
  }
};
</script>

<style lang="scss" scoped>
.dark-gray-link {
  margin-left: 5px;
}
</style>
